<script lang="ts">
import type { StudyMeetImxDataSlideProps } from '$lib/components/study/slide-layout-types'
import StudySlideStatTileCard from '../cards/StudySlideStatTileCard.svelte'
import StudySlideTextCard from '../cards/StudySlideTextCard.svelte'
import StudySlide from '../StudySlide.svelte'
import StudySlideContent from '../StudySlideContent.svelte'

/**
 * “Meet IMX Data” slide (`s3`): full slide + two-column `.tc` with imx-grid stats + text cards.
 * `eyebrow`, `headline`, and `intro` use `{@html}` — trusted study copy only.
 */
let props: StudyMeetImxDataSlideProps = $props()

const headlineStyle = props.headlineStyle ?? 'margin-bottom:.85rem;'
const introStyle = props.introStyle ?? 'margin-bottom:1.05rem;'
const tcStyle = props.tcStyle ?? 'gap:2.65rem;align-items:start;'
const tcWeighted = props.tcWeighted ?? true
</script>

<StudySlide
  id={props.id}
  active={props.active}
  extraBottom={props.extraBottom}
  background={props.background}
  slideClass={props.slideClass}
>
  <StudySlideContent
    maxWidth={props.maxWidth ?? '960px'}
    contentClass={props.contentClass}
    style={props.contentStyle}
  >
    <div class="ey">{@html props.eyebrow}</div>
    <div class="tc" class:w={tcWeighted} style={tcStyle}>
      <div>
        <div class="hl" style={headlineStyle}>{@html props.headline}</div>
        <p class="bd" style={introStyle}>{@html props.intro}</p>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:.62rem;">
          {#each props.gridTiles as tile}
            <StudySlideStatTileCard {...tile} />
          {/each}
        </div>
      </div>
      <div style="display:grid;gap:.62rem;">
        {#each props.textCards as card}
          <StudySlideTextCard {...card} />
        {/each}
      </div>
    </div>
  </StudySlideContent>
</StudySlide>
